import { render } from "./MessageManage.vue?vue&type=template&id=6e164835&scoped=true&ts=true"
import script from "./MessageManage.vue?vue&type=script&lang=ts"
export * from "./MessageManage.vue?vue&type=script&lang=ts"

import "./MessageManage.vue?vue&type=style&index=0&id=6e164835&lang=scss&scoped=true"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e164835"]])

export default __exports__